import { BARI_IDS, ConsigneeType, INSS_CARD_IDS, INSS_RETIREE_ID } from '../enums/consignee';

/**
 * Classifica um convênio a partir do seu id.
 *
 * Observação: aqui INSS considera apenas os IDs de Cartão Benefício
 * (regra usada para e-mail, margem e campos do formulário). A regra de
 * documentos, que também trata o ID 1 como INSS, usa `isInssDocuments`.
 */
export const getConsigneeType = (id?: number | string | null): ConsigneeType => {
  const numericId = Number(id);
  switch (true) {
    case INSS_CARD_IDS.includes(numericId):
      return ConsigneeType.INSS;
    case BARI_IDS.includes(numericId):
      return ConsigneeType.BARI;
    default:
      return ConsigneeType.DEFAULT;
  }
};

/** INSS para regras de e-mail / margem / campos do formulário (não inclui o ID 1). */
export const isInss = (id?: number | string | null): boolean => getConsigneeType(id) === ConsigneeType.INSS;

/** Grupo Barigui / Grupo Financeiro Bari — exibem campos extras (CNPJ + Razão Social). */
export const isBari = (id?: number | string | null): boolean => getConsigneeType(id) === ConsigneeType.BARI;

/** INSS para a regra de documentos — inclui Aposentados/Pensionistas (ID 1). */
export const isInssDocuments = (id?: number | string | null): boolean =>
  Number(id) === INSS_RETIREE_ID || isInss(id);

export interface ConsigneeFieldRules {
  /** E-mail obrigatório (para envio de nota fiscal) — convênios INSS. */
  showEmailForInvoice: boolean;
  /** Campos extras de empresa (CNPJ + Razão Social) — convênios Bari. */
  showExtraFields: boolean;
  /** Campo de margem de compra — cartão consignado, exceto INSS. */
  showPurchaseMargin: boolean;
}

/**
 * Regras de exibição/obrigatoriedade de campos derivadas do convênio.
 * Única fonte de verdade — substitui as flags calculadas inline em cada tela.
 */
export const getConsigneeFieldRules = (id?: number | string | null, hasConsignCard = false): ConsigneeFieldRules => {
  const inss = isInss(id);
  return {
    showEmailForInvoice: inss,
    showExtraFields: isBari(id),
    showPurchaseMargin: hasConsignCard && !inss,
  };
};
